(function () {
  'use strict';

  var LABEL = window.BSUB_FREQ_LABEL || 'Delivery frequency';
  var STYLE = 'margin-top:3px;font-size:13px;line-height:1.3;font-weight:500;color:#597012;';

  function format(n, unit) {
    var fr = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase() === 'fr';
    if (unit === 'day') {
      if (fr) return n + (n === 1 ? ' jour' : ' jours');
      return n + (n === 1 ? ' day' : ' days');
    }
    if (unit === 'week') {
      if (fr) return n + (n === 1 ? ' semaine' : ' semaines');
      return n + (n === 1 ? ' week' : ' weeks');
    }
    if (fr) return n + ' mois';
    return n + (n === 1 ? ' month' : ' months');
  }

  // Read Recharge's "Order Frequency and Unit" option first ('4-week'); the plan name is only a
  // fallback, and an unrecognised one yields no label rather than dumping the raw name.
  function freqLabel(sp) {
    if (!sp) return '';
    var opts = sp.options || [];
    for (var i = 0; i < opts.length; i++) {
      var v = String((opts[i] && opts[i].value) || '');
      var o = v.match(/^(\d+)\s*-\s*(day|week|month)s?$/i);
      if (o) return format(parseInt(o[1], 10), o[2].toLowerCase());
    }
    var m = String(sp.name || '').match(/(\d+)\s*(days?|jours?|weeks?|semaines?|months?|mois)/i);
    if (!m) return '';
    var unit = 'month';
    if (/^(day|jour)/i.test(m[2])) unit = 'day';
    else if (/^(week|semaine)/i.test(m[2])) unit = 'week';
    return format(parseInt(m[1], 10), unit);
  }

  var cart = null;
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; })
      .catch(function () {});
  }

  // Resolve every line to a DISTINCT item in one pass — resolving them one at a time let two
  // lines land on the same item. Exact id matches win; leftovers pair in cart order.
  function mapLinesToItems(lines) {
    var items = (cart && cart.items) || [];
    var taken = [];
    var out = [];

    lines.forEach(function (el, i) {
      var did = el.getAttribute('data-id');
      if (!did) return;
      var found = -1;
      var hits = 0;
      for (var j = 0; j < items.length; j++) {
        if (taken[j]) continue;
        var it = items[j];
        if (String(it.variant_id) === did || String(it.id) === did || String(it.key) === did) {
          found = j;
          hits++;
        }
      }
      if (hits === 1) {
        out[i] = items[found];
        taken[found] = true;
      }
    });

    var next = 0;
    for (var i = 0; i < lines.length; i++) {
      if (out[i]) continue;
      while (next < items.length && taken[next]) next++;
      if (next >= items.length) break;
      out[i] = items[next];
      taken[next] = true;
    }
    return out;
  }

  function docs() {
    var out = [];
    function add(w) {
      if (!w) return;
      var d;
      try { d = w.document; } catch (e) { return; }
      if (!d || out.indexOf(d) !== -1) return;
      out.push(d);
      var frames;
      try { frames = w.frames; } catch (e) { frames = null; }
      if (frames) {
        for (var i = 0; i < frames.length; i++) {
          try { add(frames[i]); } catch (e) {}
        }
      }
    }
    var root = window;
    try { root = window.top || window; } catch (e) { root = window; }
    add(root);
    add(window);
    return out;
  }

  function allLines() {
    var out = [];
    docs().forEach(function (d) {
      try { d.querySelectorAll('.kaktusc-cart__product').forEach(function (n) { out.push(n); }); } catch (e) {}
    });
    return out;
  }

  function inject() {
    if (!cart) return;
    var lines = allLines();
    var items = mapLinesToItems(lines);
    lines.forEach(function (el, i) {
      var content = el.querySelector('.kaktusc-cart__product-content') || el;
      var existing = content.querySelector('.bsub-cart-freq');
      var item = items[i];
      var alloc = item && item.selling_plan_allocation;
      var label = alloc ? freqLabel(alloc.selling_plan) : '';

      /* The drawer reuses its line nodes when the cart changes without a reload, so a label
         that is already on screen can belong to the plan the shopper just replaced. Emptying
         the cart and re-adding at another frequency left an 8-week choice reading back as
         "4 weeks" until the page was reloaded, and a reused node could even hang a frequency
         on the pack itself. So rewrite the label every pass, and drop it the moment its line
         stops being a subscription, rather than writing it once and trusting it. */
      if (!label) {
        if (existing) existing.remove();
        return;
      }
      if (existing) {
        var current = existing.querySelector('strong');
        if (current) {
          if (current.textContent !== label) current.textContent = label;
          return;
        }
        existing.remove();
      }
      var doc = el.ownerDocument || document;
      var node = doc.createElement('div');
      node.className = 'bsub-cart-freq';
      node.setAttribute('style', STYLE);
      node.appendChild(doc.createTextNode(LABEL + ': '));
      var strong = doc.createElement('strong');
      strong.style.fontWeight = '700';
      strong.textContent = label;
      node.appendChild(strong);
      var variant = content.querySelector('.kaktusc-cart__product-variant');
      if (variant && variant.parentNode) variant.parentNode.insertBefore(node, variant.nextSibling);
      else content.appendChild(node);
    });
  }

  /* Line count alone missed a cart whose contents changed without changing size — swap one
     flavour for another, or re-add the same eight capsules on a different plan, and the
     stale cart JSON would be reused. The ids and quantities on screen are a cheap stand-in
     for "the cart moved". */
  function signature(lines) {
    return lines
      .map(function (el) {
        var qty = el.querySelector('.kaktusc-cart__product-quantity-value, [data-quantity]');
        return (el.getAttribute('data-id') || '?') + 'x' + ((qty && qty.textContent.trim()) || '');
      })
      .join('|');
  }

  var lastSignature = null;
  function tick() {
    try {
      var lines = allLines();
      if (!lines.length) { lastSignature = null; return; }
      var sig = signature(lines);
      if (!cart || sig !== lastSignature) {
        lastSignature = sig;
        loadCart().then(inject);
      } else {
        inject();
      }
    } catch (e) {}
  }

  window.__bsubCartFreq = 'loaded';
  setInterval(tick, 400);
  tick();
})();
